import { UtilityService } from '@eforall/common';
import { GridSetup } from '@eforall/dashboard';
import { AccApplicationDialogDataService } from '../../acc-application-dialog-data.service';
import { AlignedCommitment } from '../aligned-commitments.part';
import { getActions } from './get-actions';
import { getButtons } from './get-buttons';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, accApplDialogDataService: AccApplicationDialogDataService): GridSetup<AlignedCommitment> {

	return {
		rowName: { singular: 'Commitment', plural: 'Commitments' },
		getRowKey: row => '' + row.commitmentId,
		stateKey: 'application-dialog-aligned-commitments-grid',
		actions: getActions(),
		buttons: getButtons(accApplDialogDataService),
		columns: getColumns(util),
	}
}
